// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.num6{
  padding: 0;
  margin: 0;
  background-color: #121827;
}
.about-me-section {
  padding: 20px;
  text-align: center;
  background-color: #121827;
}
.ABheader{
  font-family: "Sofia", cursive;
  font-weight: 400;
  font-style: normal;
  color: #E4B300;
  font-size: 50px;
}

.slideshow {
  display: flex;
  align-items: stretch;
  justify-content: center;
  margin-bottom: 40px;
  padding-top: 20px;
  padding-bottom: 30px;
}

.slide-left {
  flex: 1 1;
  max-width: 40%;
  margin-right: 20px;
}

.slide-left img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border: 3.8px solid;
  border-radius: 15px;
  border-color: #E4B300;
}

.slide-right {
  flex: 1 1;
  max-width: 40%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
}

.slide-content {
  text-align: left;
  padding-bottom: 40px; 
}

.slide-right h2 {
  font-size: 30px;
  color: #E4B300;
  text-align: center;
  padding-bottom: 20px;
}

.slide-right p {
  font-size: 18px;
  line-height: 1.6;
  color: #E4B300;
  text-align: center;
}

@media (max-width: 1200px) {
  .slide-right h2{
    font-size: 20px;
    padding-bottom: 15px;
  }
  .slide-right p{
    font-size: 15px;
  }
}
@media (max-width: 730px) {
  .slideshow {
    flex-direction: column;
  }

  .slide-left, .slide-right {
    max-width: 100%;
    margin: 0 0 20px 0;
  }

  .slide-left {
    margin-bottom: 20px;
  }
}

.bullets {
  display: flex;
  justify-content: center;
  position: absolute;
  bottom: 0;
  width: 100%;
}

.bullet {
  width: 12px;
  height: 12px;
  margin: 0 5px;
  border-radius: 50%;
  background-color: #ddd;
  border: none;
  cursor: pointer;
}

.bullet.active {
  background-color: #c96f02;
}

.masonry-gallery {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  grid-auto-rows: 10px; /* Controls the base height of each row */
  gap: 10px;
}

.masonry-item {
  page-break-inside: avoid;
  break-inside: avoid;
  background-color: #f3f3f3;
  padding: 4px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
}

.masonry-item img {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;
}
/* Modal Styles */
.modal {
position: fixed;
top: 0;
left: 0;
width: 100%;
height: 100%;
background-color: rgba(0, 0, 0, 0.8);
display: flex;
justify-content: center;
align-items: center;
z-index: 1000;
}

.modal img {
max-height: 80%;
max-width: 90%;
border-radius: 8px;
}

.modal-close {
position: absolute;
top: 20px;
right: 20px;
font-size: 24px;
color: white;
cursor: pointer;
background: none;
border: none;
font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/App/AboutMe.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,SAAS;EACT,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EAEjB,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE;IACE,eAAe;IACf,oBAAoB;EACtB;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,oBAAoB,EAAE,yCAAyC;EAC/D,SAAS;AACX;;AAEA;EACE,wBAAmB;EAAnB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;AACjB;AACA,iBAAiB;AACjB;AACA,eAAe;AACf,MAAM;AACN,OAAO;AACP,WAAW;AACX,YAAY;AACZ,oCAAoC;AACpC,aAAa;AACb,uBAAuB;AACvB,mBAAmB;AACnB,aAAa;AACb;;AAEA;AACA,eAAe;AACf,cAAc;AACd,kBAAkB;AAClB;;AAEA;AACA,kBAAkB;AAClB,SAAS;AACT,WAAW;AACX,eAAe;AACf,YAAY;AACZ,eAAe;AACf,gBAAgB;AAChB,YAAY;AACZ,iBAAiB;AACjB","sourcesContent":[".num6{\r\n  padding: 0;\r\n  margin: 0;\r\n  background-color: #121827;\r\n}\r\n.about-me-section {\r\n  padding: 20px;\r\n  text-align: center;\r\n  background-color: #121827;\r\n}\r\n.ABheader{\r\n  font-family: \"Sofia\", cursive;\r\n  font-weight: 400;\r\n  font-style: normal;\r\n  color: #E4B300;\r\n  font-size: 50px;\r\n}\r\n\r\n.slideshow {\r\n  display: flex;\r\n  align-items: stretch;\r\n  justify-content: center;\r\n  margin-bottom: 40px;\r\n  padding-top: 20px;\r\n  padding-bottom: 30px;\r\n}\r\n\r\n.slide-left {\r\n  flex: 1;\r\n  max-width: 40%;\r\n  margin-right: 20px;\r\n}\r\n\r\n.slide-left img {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n  border-radius: 10px;\r\n  border: 3.8px solid;\r\n  border-radius: 15px;\r\n  border-color: #E4B300;\r\n}\r\n\r\n.slide-right {\r\n  flex: 1;\r\n  max-width: 40%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n  position: relative;\r\n}\r\n\r\n.slide-content {\r\n  text-align: left;\r\n  padding-bottom: 40px; \r\n}\r\n\r\n.slide-right h2 {\r\n  font-size: 30px;\r\n  color: #E4B300;\r\n  text-align: center;\r\n  padding-bottom: 20px;\r\n}\r\n\r\n.slide-right p {\r\n  font-size: 18px;\r\n  line-height: 1.6;\r\n  color: #E4B300;\r\n  text-align: center;\r\n}\r\n\r\n@media (max-width: 1200px) {\r\n  .slide-right h2{\r\n    font-size: 20px;\r\n    padding-bottom: 15px;\r\n  }\r\n  .slide-right p{\r\n    font-size: 15px;\r\n  }\r\n}\r\n@media (max-width: 730px) {\r\n  .slideshow {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .slide-left, .slide-right {\r\n    max-width: 100%;\r\n    margin: 0 0 20px 0;\r\n  }\r\n\r\n  .slide-left {\r\n    margin-bottom: 20px;\r\n  }\r\n}\r\n\r\n.bullets {\r\n  display: flex;\r\n  justify-content: center;\r\n  position: absolute;\r\n  bottom: 0;\r\n  width: 100%;\r\n}\r\n\r\n.bullet {\r\n  width: 12px;\r\n  height: 12px;\r\n  margin: 0 5px;\r\n  border-radius: 50%;\r\n  background-color: #ddd;\r\n  border: none;\r\n  cursor: pointer;\r\n}\r\n\r\n.bullet.active {\r\n  background-color: #c96f02;\r\n}\r\n\r\n.masonry-gallery {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\r\n  grid-auto-rows: 10px; /* Controls the base height of each row */\r\n  gap: 10px;\r\n}\r\n\r\n.masonry-item {\r\n  break-inside: avoid;\r\n  background-color: #f3f3f3;\r\n  padding: 4px;\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\r\n  border-radius: 8px;\r\n}\r\n\r\n.masonry-item img {\r\n  width: 100%;\r\n  height: auto;\r\n  display: block;\r\n  border-radius: 8px;\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n  cursor: pointer;\r\n}\r\n/* Modal Styles */\r\n.modal {\r\nposition: fixed;\r\ntop: 0;\r\nleft: 0;\r\nwidth: 100%;\r\nheight: 100%;\r\nbackground-color: rgba(0, 0, 0, 0.8);\r\ndisplay: flex;\r\njustify-content: center;\r\nalign-items: center;\r\nz-index: 1000;\r\n}\r\n\r\n.modal img {\r\nmax-height: 80%;\r\nmax-width: 90%;\r\nborder-radius: 8px;\r\n}\r\n\r\n.modal-close {\r\nposition: absolute;\r\ntop: 20px;\r\nright: 20px;\r\nfont-size: 24px;\r\ncolor: white;\r\ncursor: pointer;\r\nbackground: none;\r\nborder: none;\r\nfont-weight: bold;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
